import { render, staticRenderFns } from "./SalesPaymentFailed.vue?vue&type=template&id=e3594558&"
import script from "./SalesPaymentFailed.vue?vue&type=script&lang=js&"
export * from "./SalesPaymentFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports